import styled from 'styled-components';
export const FooterBase = styled.div `
  display: flex;
  justify-content: center;

  padding: 8px;

  background: var(--color-background);
  border-top: 1px solid var(--color-border);

  & > button {
    line-height: 16px;
    flex-direction: row;

    > span::first-letter {
      text-transform: capitalize;
    }

    > i {
      margin: 0;
      margin-left: 8px;
    }
  }
`;
